var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"src":_vm.url,"scrolling":"no","frameborder":"0","width":"300px","height":"410px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }